import { render } from "./saved-item-authentication.vue?vue&type=template&id=6616da07"
import script from "./saved-item-authentication.vue?vue&type=script&lang=js"
export * from "./saved-item-authentication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__